/* DOMNO. rewards portal — the order screen: what's happening, and what you can do about it.

   10 Sep 2026. Dom: "there are many things they can do with an order... TRACK, RETURN, CHANGE
   RETURN, and then also reviews". Then: "make the buttons black and review button black also —
   maybe make it more visual, including the products they bought... a lot of text right now."
   Then: "having it just on the general order as well, where it says being packed and then it
   shows all the items that are being packed inside it... it's kind of there at all times."

   So the pieces are PICTURES, inside the status box, at every state — being packed, on its way,
   delivered. That replaced a separate "What you ordered" list further down, which said the same
   thing in more words and whose per-item button went to exactly the same place as the order-level
   one. A swap is two pictures with an arrow between them rather than two sentences. Every button
   is .btn.primary, the drawer's own black.

   DELIVERED IS REAL. I had told Dom this needed a carrier integration. Wrong: ShipStation pushes
   Royal Mail scans into Shopify, so fulfilments carry DELIVERED / IN_TRANSIT with real timestamps.
   That also gives a REAL deadline — 30 days from DELIVERY, which is what the policy says.

   MONEY BACK is read off the order, never our own estimate. Zero-value refunds are dropped by the
   worker: an order edit files one, and "£0.00 refunded" reads as a failure.

   THE API — returns.domno.com/api/portal/returns is READ ONLY, answers cross-origin, and still
   proves the customer (order + signed-in email) before it says a word. If it fails the screen
   renders without the extra blocks — never broken, never a lie.

   ⚠ CANNOT BE TESTED FROM THIS END. Signed-in screens need a real customer session and Claude has
   none, so this is proved on ?dp=harness (states O1–O5, appended by this file) and on Dom's own
   account. Add a state to the harness in the same change that adds one here.

   THE NAVIGATION TRAP: domno-portal.js keeps a PRIVATE SECTIONS list and its show() only toggles
   panels named in it, so dpGo('orderdetail') would hide everything and render a blank drawer with
   no error. SECTIONS is a closure variable, so dpGo is wrapped. reviews.js wraps it too; wrapping
   composes as long as each wrapper hides its OWN panels before delegating.
*/
(function(){
  var RETURNS_URL = 'https://returns.domno.com';
  var API = RETURNS_URL + '/api/portal/returns';
  var ORDER_RE = /^#?[A-Za-z]{0,4}\d{3,}$/;

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function orders(){ return window.DP_ORDERS || []; }
  function byName(n){ var o = orders(); for (var i=0;i<o.length;i++) if (o[i].name === n) return o[i]; return null; }
  function customerEmail(){
    try{ return (window.DP_CUSTOMER && window.DP_CUSTOMER.email) || ''; }catch(e){ return ''; }
  }
  function ownedHandles(){
    var owned = {}, o = orders();
    for (var i=0;i<o.length;i++){ var it = o[i].items || [];
      for (var j=0;j<it.length;j++) if (it[j].handle) owned[it[j].handle] = true; }
    return owned;
  }
  /* The chip read SHIPPED while the box under it said DELIVERED 5 SEP, because it
     only ever saw Liquid's o.status. It sees the worker's answer now. */
  function statusBits(o, state){
    if (!o) return { cls:'proc', label:'' };
    var os = state && state.order_state;
    if (os && os.status === 'delivered')  return { cls:'delivered', label:'Delivered' };
    if (os && os.status === 'in_transit') return { cls:'transit',   label:'On its way' };
    if (o.status === 'fulfilled') return { cls:'delivered', label:'Shipped' };
    if (o.status === 'partial')   return { cls:'transit',   label:'Part shipped' };
    return { cls:'proc', label:'Packing' };
  }
  function thumb(it){
    return '<div style="width:62px;height:78px;flex:0 0 62px;background:#f5f5f5;overflow:hidden">' +
      (it.img ? '<img src="'+esc(it.img)+'" alt="" style="width:100%;height:100%;object-fit:cover;display:block" loading="lazy">' : '') +
      '</div>';
  }
  /* the returns portal fills both fields itself from these two */
  function startReturnUrl(orderName){
    var q = [];
    if (orderName) q.push('order=' + encodeURIComponent(orderName));
    var em = customerEmail();
    if (em) q.push('identity=' + encodeURIComponent(em));
    return RETURNS_URL + '/' + (q.length ? '?' + q.join('&') : '');
  }

  function toTop(){
    try{
      var p = document.getElementById('domno-portal'); if (p) p.scrollTop = 0;
      var o = document.getElementById('dp-overlay');   if (o) o.scrollTop = 0;
      var b = document.querySelector('#domno-portal .body'); if (b) b.scrollTop = 0;
      window.scrollTo(0,0);
    }catch(e){}
  }

  /* ---------------- what the returns side says about this order ----------------
     Cached per order for the life of the drawer so flicking between screens does
     not hammer it. Never throws: a failure just means the extra blocks are absent. */
  var RET_CACHE = {};
  function returnsFor(orderName){
    if (RET_CACHE[orderName]) return RET_CACHE[orderName];
    var em = customerEmail();
    if (!em) return (RET_CACHE[orderName] = Promise.resolve(null));
    var p = fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order: orderName, identity: em })
    }).then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ return (j && j.ok) ? j : null; })
      .catch(function(){ return null; });
    RET_CACHE[orderName] = p;
    return p;
  }
  window.dpReturnsState = returnsFor;

  function line(t, v){ return esc(t) + (v ? ' &middot; ' + esc(v) : ''); }

  /* A picture of the piece beats a sentence about it. */
  function tile(img, cap, label){
    return '<div style="flex:1;min-width:0;text-align:center">' +
      '<div style="width:100%;aspect-ratio:4/5;background:#f2f2f2;overflow:hidden;margin-bottom:7px">' +
        (img ? '<img src="' + esc(img) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block" loading="lazy">' : '') +
      '</div>' +
      '<div class="c" style="font-size:8.5px;letter-spacing:.12em;margin:0">' + cap + '</div>' +
      '<div style="font-size:11px;font-weight:700;text-transform:none;line-height:1.35;margin-top:3px">' + label + '</div>' +
    '</div>';
  }
  function arrow(){
    return '<div style="flex:0 0 auto;color:#b4b4b4;font-size:15px;padding-top:22%">&rarr;</div>';
  }

  function returnLine(r){
    var items = r.items || [];
    var swaps = items.filter(function(i){ return i.swap; });
    if (swaps.length === 1){
      var sw = swaps[0];
      return '<div style="display:flex;gap:10px;align-items:flex-start">' +
        tile(sw.img, 'Sending back', line(sw.title, sw.variant)) +
        arrow() +
        tile(sw.swap_img, 'Coming to you', esc(sw.swap)) +
      '</div>';
    }
    if (swaps.length > 1){
      var h = '<div style="display:flex;gap:10px;flex-wrap:wrap">';
      for (var i=0;i<swaps.length;i++){
        h += '<div style="flex:1 1 46%;min-width:0;display:flex;gap:8px;align-items:flex-start">' +
               tile(swaps[i].img, 'Back', line(swaps[i].title, swaps[i].variant)) + arrow() +
               tile(swaps[i].swap_img, 'Out', esc(swaps[i].swap)) + '</div>';
      }
      return h + '</div>';
    }
    if (!items.length) return '<div>On its way back to us</div>';
    var g = '<div style="display:flex;gap:10px;flex-wrap:wrap">';
    for (var k=0;k<items.length && k<3;k++){
      g += '<div style="flex:0 0 31%">' + tile(items[k].img, 'Sending back', line(items[k].title, items[k].variant)) + '</div>';
    }
    return g + '</div>';
  }

  /* Each return carries its own action, because two returns on one order can be
     in different states and a single shared button can only be honest about one. */
  function returnBlock(state){
    if (!state) return '';
    var live = (state.returns || []).filter(function(r){ return r.state === 'open' || r.state === 'working'; });
    if (!live.length) return '';
    var h = '<div style="border:1px solid var(--line);padding:14px;margin-bottom:16px">';
    for (var i=0;i<live.length;i++){
      var r = live[i];
      var editable = r.state === 'open';
      var swap = r.resolution === 'exchange';
      h += (i ? '<div style="height:1px;background:var(--line);margin:14px 0"></div>' : '') +
        '<div class="n" style="font-size:13px;margin-bottom:9px">' +
          (swap ? 'Swap' : 'Return') + ' ' + esc(r.rma) + '</div>' +
        returnLine(r) +
        '<div class="c" style="text-transform:none;line-height:1.6;margin-top:10px;color:' +
          (editable ? '#1e9e4a' : '#6b6b6b') + '">' +
          (editable
            ? 'Change it or cancel it any time before it reaches us.'
            : 'Landed with us and we\'re checking it over, so this one\'s locked — the size, the piece and cancelling are all settled now. Email hi@domno.com if something\'s wrong.') +
        '</div>';
      if (state.manage_url){
        h += '<a class="btn' + (editable ? ' primary' : ' ghost') + ' block" style="margin-top:10px" href="' +
             esc(state.manage_url) + '" target="_blank" rel="noopener">' +
             (editable ? (swap ? 'Change my swap' : 'Change my return') : 'See the details') + '</a>';
      }
    }
    return h + '</div>';
  }

  /* 31 Aug, not 2026-08-31T21:50:07Z */
  function dstr(iso){
    try{
      var d = new Date(iso);
      if (isNaN(d)) return '';
      return d.getDate() + ' ' + ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()];
    }catch(e){ return ''; }
  }
  function moneyStr(r){
    var sym = { GBP:'£', USD:'$', EUR:'€', AUD:'A$' }[r.currency] || (r.currency + ' ');
    return sym + Number(r.amount).toFixed(2);
  }

  /* What is actually in the parcel, as pictures, inside the status box - so it is
     there while it is being packed, while it is on its way, and after it lands. */
  function piecesStrip(items){
    if (!items || !items.length) return '';
    var h = '<div style="display:flex;gap:8px;flex-wrap:wrap;margin-top:13px">';
    for (var i=0;i<items.length;i++){
      var it = items[i];
      h += '<div style="flex:0 0 calc(33.333% - 6px);min-width:0;text-align:center">' +
        '<div style="width:100%;aspect-ratio:4/5;background:#f2f2f2;overflow:hidden;margin-bottom:5px">' +
          (it.img ? '<img src="' + esc(it.img) + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block" loading="lazy">' : '') +
        '</div>' +
        '<div style="font-size:10px;font-weight:700;text-transform:none;line-height:1.3">' + esc(it.title) + '</div>' +
        (it.variant ? '<div class="c" style="font-size:9px;margin-top:1px">' + esc(it.variant) + '</div>' : '') +
        '<div style="font-size:9.5px;font-weight:700;margin-top:3px">' +
          (it.free ? '<span style="color:var(--red)">Free</span>' : esc(it.price)) + '</div>' +
      '</div>';
    }
    return h + '</div>';
  }

  /* The header box. Until today this said "on its way" forever, however long ago
     it landed, because Liquid has no delivered flag - but Shopify DOES know, so
     the worker reads it off the fulfilment and we can finally say so. */
  function statusBox(o, state){
    var t = (o.tracking || [])[0];
    var os = state && state.order_state;
    var track = (t && (t.company || t.number))
      ? '<div class="c" style="text-transform:none;line-height:1.6">' +
          (t.company ? esc(t.company) + '<br>' : '') + (t.number ? '<b>' + esc(t.number) + '</b>' : '') + '</div>'
      : '';

    if (os && os.status === 'delivered' && os.delivered_at){
      return '<div style="border:1px solid var(--line);padding:14px;margin-bottom:16px">' +
        '<div class="n" style="font-size:13px;margin-bottom:6px">Delivered ' + esc(dstr(os.delivered_at)) + '</div>' +
        '<div class="c" style="text-transform:none;line-height:1.6">Anything not right? You\'ve got until <b>' +
          esc(dstr(os.return_by)) + '</b> to send it back.</div>' + track + piecesStrip(o.items) + '</div>';
    }
    if (os && os.status === 'in_transit'){
      return '<div style="border:1px solid var(--line);padding:14px;margin-bottom:16px">' +
        '<div class="n" style="font-size:13px;margin-bottom:6px">On its way</div>' + track +
        (os.in_transit_at ? '<div class="c" style="text-transform:none">Left us ' + esc(dstr(os.in_transit_at)) + '</div>' : '') +
        piecesStrip(o.items) + '</div>';
    }
    if (t && (t.number || t.url)){
      return '<div style="border:1px solid var(--line);padding:14px;margin-bottom:16px">' +
        '<div class="n" style="font-size:13px;margin-bottom:6px">On its way</div>' + track + piecesStrip(o.items) + '</div>';
    }
    return '<div style="border:1px solid var(--line);padding:14px;margin-bottom:16px">' +
      '<div class="n" style="font-size:13px;margin-bottom:6px">Being packed</div>' +
      '<div class="c" style="text-transform:none;line-height:1.6">We\'ll email a tracking number the moment it leaves us.</div>' +
      piecesStrip(o.items) + '</div>';
  }

  /* Money that actually moved, read off the order - never our own estimate. */
  function refundBlock(state){
    var os = state && state.order_state;
    if (!os || !os.refunds || !os.refunds.length) return '';
    var h = '<div style="border:1px solid var(--line);padding:14px;margin-bottom:16px">' +
            '<div class="n" style="font-size:13px;margin-bottom:6px">Money back</div>';
    for (var i=0;i<os.refunds.length;i++){
      var r = os.refunds[i];
      h += '<div class="c" style="text-transform:none;line-height:1.6">' +
             '<b>' + esc(moneyStr(r)) + '</b> went back to your card on ' + esc(dstr(r.at)) + '.</div>';
    }
    return h + '<div class="c" style="text-transform:none;line-height:1.6;margin-top:5px">' +
           'Banks usually take 3&ndash;5 working days to show it.</div></div>';
  }

  function actionsBlock(o, state){
    var shipped = o && (o.status === 'fulfilled' || o.status === 'partial');
    var os = state && state.order_state;
    var hasLive = !!(state && state.live);
    var h = '<h3 class="sec">What you can do</h3>';

    h += '<button type="button" class="btn primary block" data-dp-act="track">Track this order</button>';

    if (shipped){
      h += '<a class="btn primary block" style="margin-top:8px" href="' + esc(startReturnUrl(o.name)) +
           '" target="_blank" rel="noopener">Send something back</a>' +
           '<div class="c" style="text-transform:none;margin-top:6px;line-height:1.5">' +
             (hasLive ? 'Something else from this order. ' : '') +
             (os && os.return_by
               ? 'You\'ve got until <b>' + esc(dstr(os.return_by)) + '</b>. '
               : 'You\'ve got 30 days from the day it lands. ') +
             'Earrings can\'t come back &mdash; hygiene.</div>';
    }
    return h;
  }

  /* Reviews got their own quiet block, out of the way of the two things people
     actually came for. Dom picked this over a third button in the stack, and it
     is the only place that says WHY someone would bother. */
  function reviewBlock(o){
    if (!o || o.status !== 'fulfilled') return '';
    return '<div style="background:var(--panel);border:1px solid var(--line);padding:14px;margin-top:18px">' +
      '<div class="n" style="font-size:13px;margin-bottom:5px">Got a minute?</div>' +
      '<div class="c" style="text-transform:none;line-height:1.6">Tell us how they\'re wearing. ' +
      'Add a photo and there\'s <b>a free piece</b> in it for you.</div>' +
      '<button type="button" class="btn primary block" style="margin-top:10px" data-dp-act="review">Leave a review</button>' +
      '</div>';
  }

  /* ---------------- Order screen ---------------- */
  function renderDetail(panel, name){
    var o = byName(name);
    if (!o){
      panel.innerHTML =
        '<div class="n" style="font-size:20px">' + esc(name) + '</div>' +
        '<div class="c" style="margin:6px 0 16px">Order details</div>' +
        '<div style="border:1px solid var(--line);padding:16px;text-transform:none;font-size:12px;line-height:1.6;color:#333">' +
          'We could not load the items for this order just now. Everything is safe &mdash; it is only this view.' +
        '</div>';
      return;
    }
    paint(panel, o, null);
    returnsFor(name).then(function(state){
      if (panel.getAttribute('data-dp-order') !== name) return;
      if (state) paint(panel, o, state);
    });
  }

  function paint(panel, o, state){
    panel.setAttribute('data-dp-order', o.name);
    var s = statusBits(o, state);
    var h = '<div class="rowflex" style="margin-bottom:4px">' +
              '<div class="n" style="font-size:20px">' + esc(o.name) + '</div>' +
              '<span class="stat"><span class="ind '+s.cls+'"></span>'+s.label+'</span></div>' +
            '<div class="meta" style="margin:0 0 16px">Placed ' + esc(o.created) + ' &middot; ' + esc(o.total) + '</div>';

    h += statusBox(o, state);
    h += refundBlock(state);
    h += returnBlock(state);
    h += actionsBlock(o, state);
    h += reviewBlock(o);
    panel.innerHTML = h;

    var tb = panel.querySelector('[data-dp-act="track"]');
    if (tb) tb.addEventListener('click', function(){ go('dptrack', o.name); });
    var rb = panel.querySelector('[data-dp-act="review"]');
    if (rb) rb.addEventListener('click', function(){ if (window.dpGo) window.dpGo('reviews'); });
  }

  /* ---------------- Tracking ---------------- */
  function renderTrack(panel, name){
    var o = byName(name), t = o ? (o.tracking || [])[0] : null;
    var h = '<div class="n" style="font-size:20px">Where\'s my order?</div>' +
            '<div class="c" style="margin:4px 0 16px">' + esc(name) + (t && t.company ? ' &middot; ' + esc(t.company) : '') + '</div>';
    var steps = [
      { on:true,  t:'Order placed',         s: o ? esc(o.created) : '' },
      { on:!!t,   t:'Packed and collected', s: t ? ('Left us ' + esc(t.at || '')) : 'Not yet' },
      { on:!!t,   t:'On its way',           s: t && t.company ? esc(t.company) : 'Not yet' },
      { on:false, t:'Delivered',            s: o && o.status === 'fulfilled' ? 'On its way to you' : 'Not yet' }
    ];
    h += '<div style="border:1px solid var(--line);padding:16px">';
    for (var i=0;i<steps.length;i++){
      var st = steps[i];
      h += '<div style="display:flex;gap:11px;padding:11px 0' + (i ? ';border-left:1px solid var(--line);margin-left:5px;padding-left:16px' : '') + '">' +
             '<div style="width:11px;height:11px;border-radius:50%;flex:0 0 11px;margin-top:3px;background:' + (st.on ? '#1e9e4a' : '#dcdce0') + '"></div>' +
             '<div style="flex:1"><div class="n" style="font-size:12px">' + st.t + '</div>' +
             '<div class="c" style="text-transform:none">' + st.s + '</div></div></div>';
    }
    h += '</div>';
    if (t && t.number){
      h += '<div style="background:var(--panel);border:1px solid var(--line);padding:12px;margin-top:12px;font-size:11px;text-transform:none;line-height:1.6;color:#333">' +
           'Tracking number <b style="text-transform:uppercase">' + esc(t.number) + '</b><br>Updates come from the carrier and can lag by a few hours.</div>';
    }
    if (t && t.url){
      h += '<a class="btn primary block" style="margin-top:12px" href="'+esc(t.url)+'" target="_blank" rel="noopener">Track with the carrier</a>';
    }
    panel.innerHTML = h;
  }

  /* ---------------- Returns list (menu screen) ---------------- */
  function renderReturns(panel){
    var out = [], seen = {}, o = orders();
    for (var i=0;i<o.length;i++){
      if (o[i].status !== 'fulfilled') continue;
      var items = o[i].items || [];
      for (var j=0;j<items.length;j++){
        var it = items[j];
        if (!it.handle || seen[it.handle + o[i].name]) continue;
        seen[it.handle + o[i].name] = true;
        out.push({ it: it, order: o[i].name });
      }
    }
    var h = '<h3 class="sec">Return an item</h3>' +
            '<div class="c" style="margin:0 2px 16px;line-height:1.6">30 days from delivery. Earrings can\'t come back &mdash; hygiene.</div>';
    if (!out.length){
      h += '<div class="c" style="text-align:center;padding:34px 16px;line-height:1.8">' +
           '<div style="font-family:var(--disp);font-weight:900;font-style:italic;font-size:17px;color:var(--ink);margin-bottom:8px">Nothing to return yet</div>' +
           'Once an order arrives, everything in it shows up here.</div>';
    } else {
      for (var k=0;k<out.length;k++){
        var r = out[k];
        h += '<div class="rw" style="align-items:flex-start;gap:11px">' + thumb(r.it) +
               '<div style="flex:1;min-width:0">' +
                 '<div class="n" style="font-size:13px">' + esc(r.it.title) + '</div>' +
                 '<div class="c">' + esc([r.it.variant, r.order].filter(Boolean).join(' · ')) + '</div>' +
                 '<a class="btn primary" style="width:auto;padding:8px 12px;margin-top:9px" href="'+esc(startReturnUrl(r.order))+'" target="_blank" rel="noopener">Start return</a>' +
               '</div></div>';
      }
      h += '<div class="c" style="margin-top:14px;line-height:1.6;text-transform:none">Opens our returns portal in a new tab, with your order already filled in.</div>';
    }
    panel.innerHTML = h;
  }

  /* ---------------- Recommended for you ---------------- */
  function renderRecs(){
    var grid = document.querySelector('#p-home .recgrid');
    var recs = window.DP_RECS || [];
    if (!grid || !recs.length) return false;
    var owned = ownedHandles(), pool = [];
    for (var i=0;i<recs.length;i++) if (!owned[recs[i].handle]) pool.push(recs[i]);
    if (pool.length < 3) pool = recs;
    pool = pool.slice(0, 10);
    var h = '';
    for (var k=0;k<pool.length;k++){
      var p = pool[k];
      h += '<div class="prod"><a href="'+esc(p.url)+'" style="text-decoration:none;color:inherit;display:block">' +
             '<div class="img">' + (p.img ? '<img src="'+esc(p.img)+'" alt="'+esc(p.title)+'" loading="lazy">' : '') + '</div>' +
             '<div class="pinfo"><div class="pname">'+esc(p.title)+'</div><div class="pprice">'+esc(p.price)+'</div></div>' +
           '</a></div>';
    }
    grid.innerHTML = h;
    return true;
  }

  /* ---------------- harness states, painted by the REAL functions -------------- */
  function harness(){
    if (new URLSearchParams(location.search).get('dp') !== 'harness') return;

    var RINGIMG = 'https://cdn.shopify.com/s/files/1/0305/7100/4043/files/10-ball-ring-1_200x.jpg?v=1783020963';
    var BALLIMG = 'https://cdn.shopify.com/s/files/1/0305/7100/4043/files/Minimal8BallRing01_200x.jpg?v=1772537926';

    var order = {
      name: 'D86402', created: '4 Sep 2026', total: '£88.50', status: 'fulfilled',
      tracking: [{ company: 'Royal Mail', number: 'AB123456789GB', at: '5 Sep' }],
      items: [
        { title: '10 Ball Ring', variant: '6', price: '£25.00', handle: '10-ball-ring', img: RINGIMG },
        { title: 'Minimal 8 Ball Ring', variant: '8', price: '£25.00', handle: 'minimal-8-ball', img: BALLIMG },
        { title: 'Cuban Chain 5mm', variant: 'Silver / 50cm', price: '£38.50', handle: 'cuban-chain', img: RINGIMG }
      ]
    };
    var packing = JSON.parse(JSON.stringify(order));
    packing.status = 'unfulfilled'; packing.tracking = [];

    var DELIVERED = { status:'delivered', delivered_at:'2026-09-05T10:00:00Z',
                     in_transit_at:'2026-09-03T09:00:00Z', return_by:'2026-10-05T10:00:00Z', refunds:[] };
    var REFUNDED = { status:'delivered', delivered_at:'2026-09-05T10:00:00Z',
                     in_transit_at:'2026-09-03T09:00:00Z', return_by:'2026-10-05T10:00:00Z',
                     refunds:[{ amount:'45.00', currency:'GBP', at:'2026-09-12T10:00:00Z' }] };
    var SWAPITEM = { title:'10 Ball Ring', variant:'6', img:RINGIMG,
                     swap:'Minimal 8 Ball Ring · 8', swap_img:BALLIMG };

    var swapState = { live:1, can_edit:true, manage_url:'#', order_state:DELIVERED, returns:[
      { rma:'D86402-R1', state:'open', resolution:'exchange', items:[SWAPITEM] } ] };
    var lockedState = { live:1, can_edit:false, manage_url:'#', order_state:DELIVERED, returns:[
      { rma:'D86402-R1', state:'working', resolution:'exchange', items:[SWAPITEM] } ] };
    var twoState = { live:2, can_edit:true, manage_url:'#', order_state:REFUNDED, returns:[
      { rma:'D86402-R2', state:'open', resolution:'refund',
        items:[{ title:'Cuban Chain 5mm', variant:'Silver / 50cm', img:RINGIMG, swap:null }] },
      { rma:'D86402-R1', state:'working', resolution:'exchange', items:[SWAPITEM] } ] };

    var screens = [
      ['O1','Order, still being packed','no tracking yet, nothing returnable', packing, null],
      ['O2','Delivered, nothing returned','the everyday case', order, { live:0, can_edit:false, order_state:DELIVERED, returns:[] }],
      ['O3','Swap in flight, still editable','the parcel has not reached us', order, swapState],
      ['O4','Return with us','on the bench, so the change button is gone', order, lockedState],
      ['O5','Two returns + a refund','one open, one with us, money already back', order, twoState]
    ];

    var tries = 0, iv = setInterval(function(){
      tries++;
      var grid = document.querySelector('#dp-harness .grid');
      if (!grid){ if (tries > 60) clearInterval(iv); return; }
      clearInterval(iv);
      var css = document.createElement('style');
      css.textContent =
        '#dp-harness .p .sec{font-family:var(--disp);font-weight:900;font-style:italic;font-size:12px;' +
          'margin:14px 0 8px;text-transform:uppercase}' +
        '#dp-harness .p .n{font-weight:700;font-size:12px}' +
        '#dp-harness .p .c{color:var(--dim);font-size:10px;letter-spacing:.06em;margin-top:2px}' +
        '#dp-harness .p .meta{color:var(--dim);font-size:10px;letter-spacing:.06em}' +
        '#dp-harness .p .rowflex{display:flex;justify-content:space-between;align-items:center}' +
        '#dp-harness .p .stat{font-size:9px;letter-spacing:.1em;display:flex;align-items:center;gap:5px}' +
        '#dp-harness .p .ind{width:7px;height:7px;border-radius:50%;background:#1e9e4a;display:inline-block}' +
        '#dp-harness .p .ind.proc{background:#b06a00}#dp-harness .p .ind.transit{background:#1461b5}' +
        '#dp-harness .p a.btn{text-decoration:none}' +
        '#dp-harness .p .btn.primary{background:#111;color:#fff;border-color:#111}';
      document.head.appendChild(css);

      var html = '';
      for (var i=0;i<screens.length;i++){
        var s = screens[i], o = s[3], st = s[4];
        var bits = statusBits(o, st);
        var inner =
          '<div class="rowflex" style="margin-bottom:4px"><div class="n" style="font-size:17px">' + esc(o.name) + '</div>' +
          '<span class="stat"><span class="ind ' + bits.cls + '"></span>' + bits.label + '</span></div>' +
          '<div class="meta" style="margin:0 0 12px">Placed ' + esc(o.created) + ' &middot; ' + esc(o.total) + '</div>' +
          statusBox(o, st) + refundBlock(st) + returnBlock(st) + actionsBlock(o, st) + reviewBlock(o);
        html += '<div class="card"><div class="cap"><div class="id">' + s[0] + '</div>' +
                '<div class="nm">' + s[1] + '</div><div class="wh">' + s[2] + '</div></div>' +
                '<div class="scr"><div class="p">' + inner + '</div></div></div>';
      }
      grid.insertAdjacentHTML('beforeend', html);
    }, 120);
  }
  harness();

  /* ---------------- panels + navigation ---------------- */
  var PANELS = { orderdetail: renderDetail, dptrack: renderTrack };
  var current = null, currentOrder = null;

  function ensurePanel(id){
    var p = document.getElementById('p-' + id); if (p) return p;
    var body = document.querySelector('#domno-portal .body'); if (!body) return null;
    p = document.createElement('div'); p.id = 'p-' + id; p.className = 'panel';
    body.appendChild(p); return p;
  }
  function hideOurs(){
    ['orderdetail','dptrack'].forEach(function(id){
      var p = document.getElementById('p-' + id); if (p) p.classList.remove('on'); });
  }
  function go(id, arg){
    var p = ensurePanel(id); if (!p) return;
    var all = document.querySelectorAll('#domno-portal .panel');
    for (var i=0;i<all.length;i++) all[i].classList.remove('on');
    var mi = document.querySelectorAll('#dp-menu a');
    for (var j=0;j<mi.length;j++) mi[j].classList.remove('on');
    if (PANELS[id]) PANELS[id](p, arg);
    p.classList.add('on');
    current = id; currentOrder = arg || currentOrder;
    var menu = document.getElementById('dp-menu'); if (menu) menu.classList.remove('on');
    var back = document.getElementById('dp-back'); if (back) back.style.display = 'block';
    toTop();
  }
  window.dpOpenOrder = function(name){ go('orderdetail', name); };

  /* ---- the order's own button is the only way in, and it says what it does ---- */
  function wireOrderButtons(){
    var cards = document.querySelectorAll('#p-orders .card, #p-home .card');
    for (var i=0;i<cards.length;i++){
      var card = cards[i];
      var nEl = card.querySelector('.n');
      if (!nEl) continue;
      var nm = (nEl.textContent||'').trim();
      if (!ORDER_RE.test(nm)) continue;

      var links = card.querySelectorAll('a,button');
      for (var j=0;j<links.length;j++){
        var el = links[j];
        if (el.getAttribute('data-dp-track-btn')) continue;
        var txt = el.textContent || '';
        if (!/track|view order/i.test(txt)) continue;
        el.setAttribute('data-dp-track-btn','1');
        el.textContent = 'View order';
        (function(name, node){
          node.addEventListener('click', function(e){
            e.preventDefault(); e.stopPropagation();
            go('orderdetail', name);
          }, true);
        })(nm, el);
      }
    }
  }

  /* "View all orders" is a bare grey div in the Liquid. Make it look like the button it is. */
  function fixViewAll(){
    var links = document.querySelectorAll('#p-home .link');
    for (var i=0;i<links.length;i++){
      if (!/view all orders/i.test(links[i].textContent || '')) continue;
      if (links[i].getAttribute('data-dp-btn')) continue;
      links[i].setAttribute('data-dp-btn','1');
      links[i].className = 'btn ghost block';
      links[i].style.marginTop = '4px';
      links[i].style.cursor = 'pointer';
    }
  }

  function install(){
    if (typeof window.dpGo !== 'function') return false;
    var body = document.querySelector('#domno-portal .body');
    if (!body) return false;
    if (body.getAttribute('data-dp-orders-wired')) return true;
    body.setAttribute('data-dp-orders-wired','1');

    wireOrderButtons();
    fixViewAll();
    renderRecs();
    var rp = document.getElementById('p-returns'); if (rp) renderReturns(rp);

    var origGo = window.dpGo;
    window.dpGo = function(id){
      hideOurs(); current = null;
      var r;
      try{ r = origGo.apply(this, arguments); }catch(e){}
      wireOrderButtons(); fixViewAll();
      toTop();
      return r;
    };

    var origBack = window.dpBack;
    window.dpBack = function(){
      if (current === 'dptrack' && currentOrder){ go('orderdetail', currentOrder); return; }
      if (current){ hideOurs(); current = null; if (window.dpGo) window.dpGo('orders'); return; }
      var r; try{ r = origBack.apply(this, arguments); }catch(e){}
      toTop();
      return r;
    };

    return true;
  }

  if (!install()){
    var n = 0, iv = setInterval(function(){ n++; if (install() || n > 80) clearInterval(iv); }, 100);
  }
})();
